import React, {Component} from 'react';
import { Button } from 'carbon-components-react';
import PropertyComponent from './PropertyComponent';
import * as midi from '../js/rpl_midi.js';

/*
 * A button that sends a MIDI continuous controller value on click.
 *
 * Properties:
 * textLabel: label
 * ccNum: MIDI continuous controller number
 * onValue: value send when button is clicked
 */
class CCButton extends PropertyComponent {

	constructor(props) {
		super(props);

		this.ccNum     = props.ccNum;
		this.onValue   = props.onValue;
		this.textLabel = props.textLabel;
		this.kind      = props.kind || "primary";
		this.size      = props.size || "default";

		this.handleClick = this.handleClick.bind(this);
	}

	render() {
		return (
			<Button kind={this.kind} size={this.size} onClick={this.handleClick}>
			  {this.textLabel}
			</Button>
		);
	}

	handleClick(props) {
		midi.sendControlChange(this.ccNum, this.onValue);
	}
}

export default CCButton;
